import { render } from "./SearchBar.vue?vue&type=template&id=8a893c12&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=8a893c12&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\travelsite-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a893c12"]])

export default __exports__